import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('procedureModule')
        .factory('procedureService', service);

    service.$inject = ['$http', 'attachmentService'];

    function service($http, attachmentService) {
        var baseUrl = environment.apiUrl + '/Pilot/api/Procedure';

        function returnData(response) {
            return response.data;
        }

        return {
            /**
             * Gets the procedure without specifying procedure type to get the procedure object,
             * which is used to get its ProcedureType to redirect user to the correct route.
             * This is necessary to support old route and redirect to the correct one.
             */
            getProcedureForRedirection: function (procedureCode, options) {
                return $http
                    .get(baseUrl + '/' + procedureCode + '/For/View', options)
                    .then(returnData);
            },

            /**
             * This route is necessary to get Ref Docs from Solr results as Solr only returns the Procedure Codes
             */
            getReferenceDocumentForView: function (procedureCode, opt) {
                return $http
                    .get(baseUrl + '/Reference-Document/' + procedureCode + '/For/View', opt)
                    .then(returnData);
            },

            getProcedureForView: function (procedureType, procedureCode, opt) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/' + procedureCode + '/For/View', opt)
                    .then(returnData);
            },

            getPublishedProcedureView: function (procedureType, procedureCode, opt) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/' + procedureCode + '/For/View/Version/Published', opt)
                    .then(returnData);
            },

            getWorkingCopyProcedureView: function (procedureType, procedureCode, opt) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/' + procedureCode + '/For/View/Version/WorkingCopy', opt)
                    .then(returnData);
            },

            getProcedureForEdit: function (procedureType, procedureCode) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/' + procedureCode + '/For/Edit')
                    .then(returnData);
            },

            // Get Procedure Draft
            getProcedureDraft: function (procedureType, data) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/Draft', {
                        params: data
                    })
                    .then(returnData);
            },

            getProcedureAsDocxUrl: function (procedureType, procedureCode, language, version) {
              return $http
                .get(baseUrl
                  + '/' + procedureType + '/' + procedureCode
                  + '/For/Document/And/Language/' + language
                  + '/Version/' + version, { responseType: 'arraybuffer' }
                )
                .then(returnData);
            },

            // Check if Procedure can be safely deleted
            checkIfCanSafelyDelete: function (procedureType, procedureId) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/' + procedureId + '/Check/If/Can/Safely/Delete')
                    .then(returnData);
            },

            deleteProcedure: function (procedureType, procedureId) {
                return $http
                    .delete(baseUrl + '/' + procedureType + '/' + procedureId)
                    .then(returnData);
            },

            getAllBusinessUnits: function () {
                return $http
                    .get(environment.apiUrl + '/Pilot/api/BusinessUnit', {cache: true})
                    .then(returnData);
            },

            getAvailableProcedureCode: function (metadataBlock) {
                return $http
                    .post(baseUrl + '/' + metadataBlock.ProcedureType.Value + '/AvailableCode', metadataBlock)
                    .then(returnData);
            },

            publishProcedure: function (procedureType, procedureId) {
                return $http
                    .post(baseUrl + '/' + procedureType + '/' + procedureId + '/Publish')
                    .then(returnData)
            },

            unpublishProcedure: function (procedureType, procedureId) {
                return $http
                    .post(baseUrl + '/' + procedureType + '/' + procedureId + '/Unpublish')
                    .then(returnData)
            },

            updateReviewers: function (procedureType, procedureId, reviewerBlock) {
                return $http
                    .post(baseUrl + '/' + procedureType + '/' + procedureId + '/ReviewerBlock', reviewerBlock)
            },

            // Reference Document
            updateReferenceDocumentWithOwnersAndReaders: function (procedure) {
                return $http
                    .put(baseUrl + '/' + procedure.MetadataBlock.ProcedureType.Value
                                 + '/' + procedure.ProcedureID + '/With/Owners/And/Readers', {
                        owners: procedure.Owners,
                        readers: procedure.Readers
                    })
                    .then(returnData)
            },

            // Metadata Block
            createProcedureAndMetadataBlock: function (metadataBlock, procedureType) {
                return $http
                    .post(baseUrl + '/' + procedureType + '/And/MetadataBlock', metadataBlock)
                    .then(returnData);
            },

            updateProcedureMetadataBlock: function (procedureId, metadataBlock, procedureType) {
                return $http
                    .put(baseUrl + '/' + procedureType + '/' + procedureId +
                        '/MetadataBlock/' + metadataBlock.MetadataBlockID,
                        metadataBlock)
                    .then(returnData);
            },
            requestReviewMetadataBlock: function(procedureType, procedureId, metadataBlockId) {
                return $http
                    .post(baseUrl
                        + '/' + procedureType + '/' + procedureId
                        + '/MetadataBlock/' + metadataBlockId + '/Review/Request')
                    .then(returnData);
            },

            getAllMetadataBlockLookupAttributes: function () {
                return $http
                    .get(environment.apiUrl + '/Pilot/api/LookupAttribute/Value/For/MetadataBlock', {cache: true})
                    .then(returnData);
            },

            getProcedureTypesForCreation: function () {
                return $http
                    .get(baseUrl + '/Type/For/Creation', {cache: true})
                    .then(returnData);
            },

            getMetadataBlocksToCompare: function (procedureType, procedureId, metadataBlockId) {
                return $http
                    .get(baseUrl
                        + '/' + procedureType + '/' + procedureId
                        + '/MetadataBlock/' + metadataBlockId
                        + '/Differences/With/Version/Published')
                    .then(returnData);
            },

            cancelReviewMetadataBlock: function (procedureType, procedureId, metadataBlockId) {
                return $http
                    .post(baseUrl
                        + '/' + procedureType
                        + '/' + procedureId
                        + '/MetadataBlock/' + metadataBlockId
                        + '/Review/Cancel')
                    .then(returnData);
            },

            approveReviewMetadataBlock: function (procedureType, procedureId, metadataBlockId) {
                return $http
                    .post(baseUrl
                        + '/' + procedureType
                        + '/' + procedureId
                        + '/MetadataBlock/' + metadataBlockId
                        + '/Review/Approve')
                    .then(returnData);
            },

            // Section Block
            getSectionBlock: function (procedureType, procedureId, sectionBlockId) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/' + procedureId + '/SectionBlock/' + sectionBlockId)
                    .then(returnData);
            },

            getSectionBlocks: function (procedureType, procedureId) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/' + procedureId + '/SectionBlock')
                    .then(returnData);
            },

            createSectionBlock: function (procedureType, sectionId, sectionBlock, sectionBlockIDs) {
                var container = {
                    SectionBlock: sectionBlock,
                    OrderedSectionBlockIDs: sectionBlockIDs
                };
                return $http
                    .post(baseUrl + '/' + procedureType + '/' + sectionId + '/SectionBlock', container)
                    .then(returnData);
            },


            updateSectionBlock: function (procedureType, sectionId, sectionBlock) {
                return $http
                    .put(baseUrl + '/' + procedureType
                                 + '/' + sectionId
                                 + '/SectionBlock/' + sectionBlock.SectionBlockID, sectionBlock)
                    .then(returnData);
            },

            requestReviewSectionBlock: function(procedureType, procedureId, sectionId) {
                return $http
                    .post(baseUrl
                        + '/' + procedureType + '/' + procedureId
                        + '/SectionBlock/' + sectionId
                        + '/Review/Request')
                    .then(returnData);
            },

            cancelReviewSectionBlock: function (procedureType, procedureId, sectionId) {
                return $http
                    .post(baseUrl
                        + '/' + procedureType + '/' + procedureId
                        + '/SectionBlock/' + sectionId
                        + '/Review/Cancel')
                    .then(returnData);
            },

            approveReviewSectionBlock: function (procedureType, procedureId, sectionId) {
                return $http
                    .post(baseUrl
                        + '/' + procedureType + '/' + procedureId
                        + '/SectionBlock/' + sectionId
                        + '/Review/Approve')
                    .then(returnData);
            },

            compareSectionBlock: function (procedureType, procedureId, sectionId) {
                return $http
                    .get(baseUrl
                        + '/' + procedureType + '/' + procedureId
                        + '/SectionBlock/' + sectionId
                        + '/Differences/With/Version/Published')
                    .then(returnData);
            },

            // Check if Section Block can be safely deleted
            checkIfCanSafelyDeleteSectionBlock: function (procedureType, sectionId) {
                return $http
                    .get(baseUrl + '/' + procedureType + '/SectionBlock/' + sectionId + '/Check/If/Can/Safely/Delete')
                    .then(returnData);
            },

            deleteSectionBlock: function (procedureType, procedureId, sectionBlock) {
                return $http
                    .delete(baseUrl + '/' + procedureType + '/' + procedureId + '/SectionBlock/' + sectionBlock.SectionBlockID)
                    .then(returnData);
            },

            orderSectionBlocks: function (procedureType, procedureId, sectionBlockIds) {
                return $http
                    .put(baseUrl + '/' + procedureType + '/' + procedureId + '/SectionBlock/Order', sectionBlockIds)
                    .then(returnData);
            },

            getMarkdownInfo: function (procedureType, procedureId, content) {
                return $http
                    .post(baseUrl + '/' + procedureType + '/' + procedureId + '/SectionBlock/MarkdownInfo', {content: content})
                    .then(returnData);
            },

            getAllSectionBlockLookupAttributes: function () {
                return $http
                    .get(environment.apiUrl + '/Pilot/api/LookupAttribute/Value/For/SectionBlock')
                    .then(returnData);
            },

            getAllCommittees: function () {
                return $http
                    .get(environment.apiUrl + '/Pilot/api/Committee')
                    .then(returnData);
            },

            getAllCorporateRoles: function () {
                return $http
                    .get(environment.apiUrl + '/Pilot/api/CorporateRole')
                    .then(returnData);
            },

            // Validate Translation on Section Block
            validateTranslationSectionBlock: function (procedureType, sectionBlock) {
                return $http
                    .post(baseUrl + '/' + procedureType + '/SectionBlock/Translation/Validation', sectionBlock)
                    .then(returnData);
            }
        };
    }
})();
